angular
  .module('customer')

  .factory('DestinationUseDocumentCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class DestinationUseDocumentCrud extends Crud {
        constructor(list) {
          super(
            'destinationUseDocuments' + (list || ''),
            '@@apiUrl' + '/destinationUseDocuments' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return DestinationUseDocumentCrud;
    }
  ]);
